import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCoinRand: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"coin-rand, currency, money"} maskId="square-filled-radius-0-stroke-1-IconCoinRand"><path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM9 11H7V12H9V17H10V8.73145L13.6748 17H15V12H17V11H15V7H14V15.2686L10.3252 7H9V11Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCoinRand;
